import { TweenMax } from "gsap/umd/TweenMax";

'use strict';

jQuery($ => {

    const swiperOpts = {
        autoplay: {
            delay: 5000,
        },
        slidesOffsetBefore: 64,
        slidesOffsetAfter: 64,
        spaceBetween: 64,
        slidesPerView: 5,
        loop: true,
        disableOnInteraction: false,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            360: {
                slidesOffsetBefore: 0,
                slidesOffsetAfter: 0,
                slidesPerView: 1,
                spaceBetween: 16
            },
            480: {
                slidesOffsetBefore: 0,
                slidesOffsetAfter: 0,
                slidesPerView: 2,
                spaceBetween: 24
            },
            640: {
                slidesOffsetBefore: 16,
                slidesOffsetAfter: 16,
                slidesPerView: 3,
                spaceBetween: 32
            },
            860: {
                slidesOffsetBefore: 32,
                slidesOffsetAfter: 32,
                slidesPerView: 4,
                spaceBetween: 48
            }
        }
    };

    $('.gecko-builder-sponsors__container').each((i, ui) => {
        const swiper = new Swiper($(ui), swiperOpts);
    });
});
